import api from "../../../utils/api";

const requestToken = async () => {
  const { json } = await api.post('preserve');
  return json.token;
};

export { requestToken };